import { useQuery } from "@tanstack/react-query";
import DashboardService from "src/apis/DashboardService";
import { toast } from "react-toastify";
import { withNamespaces } from "react-i18next";
import DamageAnalytics from "../../Charts/DamageAnalytics";

const DashboardCasesByDate = ({ t, filters, modules }) => {
  const { data: dashboardData, isFetching: dataIsFetching } = useQuery({
    queryKey: ["wb-cm-fetch-admin-dashboard-cases-by-date-query", filters],
    queryFn: async () => {
      const service = DashboardService.getInstance();
      return await service.fetchCasesByDate(
        {
          ...filters,
          excludeDeleted: (filters.exclude || []).includes("deleted_cases"),
          excludeTestCases: (filters.exclude || []).includes("test_cases"),
          exclude: undefined,
        },
        modules?.active
      );
    },
    cacheTime: 0,
    refetchOnWindowFocus: false,
    onError: (error) => {
      if (process.env.NODE_ENV === "development") console.error(error);

      toast(t("An error occurred while fetching dashboard data."), {
        type: "error",
      });
    },
  });

  return (
    <DamageAnalytics
      data={dashboardData?.typesByDate || []}
      loading={dataIsFetching}
    />
  );
};

export default withNamespaces()(DashboardCasesByDate);
